import styled from "styled-components";

export const IconWrapper = styled.svg`
  margin-right: 4px;
`;

export const CardWrapper = styled.div`
  margin-bottom: 28px;
`;
